import client from '.'

export const apiGetListNotifications = (page: number, size: number) => {
  return client.get(`/reports?page=${page}&size=${size}`).then((res) => res.data)
}

export const apiDeleteNotification = (notificationId: string) => {
  return client.delete(`/reports/${notificationId}`).then((res) => res.data)
}
